import { createSlice } from "@reduxjs/toolkit";

const movieSlice = createSlice({
    name:'movies',
    initialState:{
        trendingMovies:null,
        nowPlayingMovies:null,
        popularMovies:null,
        topRatedMovies:null,
        trailerVideo:null,
        moviesGenreIds:null,
        movieDetails:null,
        showVideo:false,
    },
    reducers:{
        addTrendingMovies:(state,action)=>{
            state.trendingMovies = action.payload;
        },
        addNowPlayingMovies : (state,action)=>{
            state.nowPlayingMovies = action.payload;
        },
        addTrailerVideo : (state,action)=>{
            state.trailerVideo = action.payload;
        },

        addPopularMovies : (state,action)=>{
            state.popularMovies = action.payload;
        },
        addTopRatedMovies : (state,action)=>{
            state.topRatedMovies = action.payload;
        },
        addGenreIds : (state,action)=>{
            state.moviesGenreIds = action.payload;
        },
        addMovieDetails: (state,action)=>{
            state.movieDetails = action.payload;
        },
        clearMovieDetails: (state,action)=>{
            state.movieDetails = null;
        },
        toggleShowVideo: (state,action)=>{
            state.showVideo = !state.showVideo;
        },
    }
})


export const {addTrendingMovies,addNowPlayingMovies, addTrailerVideo, addGenreIds, addTopRatedMovies, addPopularMovies, addMovieDetails, clearMovieDetails, toggleShowVideo} = movieSlice.actions;
export default movieSlice.reducer;